import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@onclicks/sharedcomponents/ui/Input'
import { Label } from '@onclicks/sharedcomponents/ui/Label'
import { Width } from '@onclicks/sharedcomponents/FieldForm/Width'
import React from 'react'

import { Error } from '@onclicks/sharedcomponents/FieldForm/Error'

export const Number: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, register, required, width }) => {
  return (
    <Width width={width} className="flex flex-col gap-2">
      <Label htmlFor={name} className="text-primary font-bold">
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type="number"
        className="rounded-full border-2 border-secondary bg-white/30 text-primary placeholder:text-primary/60 focus-visible:ring-secondary/50 focus-visible:ring-offset-0"
        {...register(name, { required })}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
